import { render, staticRenderFns } from "./GoodsList.vue?vue&type=template&id=739fa38d&scoped=true&"
import script from "./GoodsList.vue?vue&type=script&lang=js&"
export * from "./GoodsList.vue?vue&type=script&lang=js&"
import style0 from "./GoodsList.vue?vue&type=style&index=0&id=739fa38d&lang=scss&scoped=true&"
import style1 from "./GoodsList.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "739fa38d",
  null
  
)

export default component.exports